<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="visible"
    :title="title"
    width="30%"
  >
    <div style="padding: 30px 50px;position: relative;left: -10px;">
      <span class="formContent">
        <el-form :model="apprInfo"  :rules="rules" ref="apprInfo" label-width="80px">
          <el-form-item label="审批人:" prop="empId">
            <el-select v-model="apprInfo.empId" filterable :loading="loading" placeholder="请选择审批人">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.empName"
                :value="item.id">
                <span style="float: left">{{ item.empName }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.dept }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
    </span>
    </div>
      <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="mini" @click="submitForm()">保存</el-button>
      <el-button size="mini" @click="closeForm">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import {getAllEmpByCusId,add,update,queryEmpIsExist} from  "@/api/appr/apprInfo"
  export default {
    data() {
      return {
        visible: false,
        title:'',
        gradeTxt:'',
        options:[],
        loading:false,
        apprInfo: {
          id: '',
          empId: '',
          grade: '',
          status: '1',
          cityCode:'',
        },
        rules:{
          empId: [
            { required: true, message: '请选择审批人', trigger: 'change' }
          ],
        }
      };
    },
    methods:{
      //打开弹窗加载数据
      init(operation,isUse,BasicInfo,data,cityCode){
        this.apprInfo.status = isUse;
        this.apprInfo.cityCode = cityCode;
        if(BasicInfo.length != 0){
          this.apprInfo.id = BasicInfo.id;
          this.apprInfo.empId = BasicInfo.empId;
          this.apprInfo.grade = BasicInfo.grade;
          this.apprInfo.status = BasicInfo.status;
        }
        this.visible = true;
        this.gradeTxt = data.label;
        if(operation == "add"){
          this.title = "新增"+this.gradeTxt;
        }else{
          this.title = "修改"+this.gradeTxt;
        }
        this.apprInfo.grade = data.id;
        this.initEmp();
      },
      //查询人员
      initEmp(){
        this.loading = true;
        getAllEmpByCusId().then(res => {
          if(res.data.code == 0){
            this.options = res.data.data;
            this.loading = false;
          }
        })
      },

      //保存/修改
      submitForm(){
        this.$refs["apprInfo"].validate((valid) => {
          if (valid) {
            this.$confirm("确认将该其设置为"+this.gradeTxt+"吗？","提示" , {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: 'warning'
            }).then(() => {
              //校验当前员工是否已被设置为其他级别审批人
              queryEmpIsExist({"empId":this.apprInfo.empId,"grade":this.apprInfo.grade,"cityCode":this.apprInfo.cityCode}).then(res =>{
                if(res.data.code == 0 && res.data.data.flag){
                  if(this.apprInfo.id != ''&&this.apprInfo.id != null){
                    //修改
                    update(this.apprInfo).then(res =>{
                      if(res.data.code == 0){
                        this.closeForm();
                        this.$message.success("修改成功");
                        // 子组件中触发父组件的初始化方法
                        this.$emit('refresh', '')
                      }else{
                        this.$message.error("新增失败");
                      }
                    })
                  }else{
                    //新增
                    add(this.apprInfo).then(res =>{
                      if(res.data.code == 0){
                        this.closeForm();
                        this.$message.success("新增成功");
                        // 子组件中触发父组件的初始化方法
                        this.$emit('refresh', '')
                      }else{
                        this.$message.error("新增失败");
                      }
                    })
                  }
                }else{
                  this.$message.error(res.data.data.msg);
                }
              });
            })
          }
        })
      },

      //关闭弹窗
      closeForm() {
        this.visible = false;
        // 重置表单
        this.$refs["apprInfo"].resetFields();
        this.value = "";
        this.apprInfo.id = '';
        this.apprInfo.empId = '';
        this.apprInfo.grade = '';
        this.apprInfo.status = '1';
      },
    }
  }
</script>
<style scoped  rel="stylesheet/scss">
  /deep/ .el-dialog{
    top: 12vh !important;
    left: 1% !important;
  }
  .sideBarForm {
    overflow: auto;
    height: calc(100vh - 80px);
    margin-top: 40px;
  }
  .fullScreen .formHead,
  .fullScreen .formButton {
    right: 0;
  }
  .formHead {
    position: fixed;
    right: -420px;
    top: 0;
    background-color: #27c3dc;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index: 1100;
  }
  .formBack {
    width: 40px;
    text-align: center;
    height: 100%;
    background-color: #ffbf00;
    font-size: 16px;
    color: #ffffff;
    line-height: 40px;
    cursor: pointer;
  }
  .formContent {
    padding: 20px;
  }
  .formButton {
    position: fixed;
    right: -420px;
    bottom: 0;
    background-color: #ffffff;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index: 1100;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
